import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { InformationCard } from 'feature/informationCard'
import { MainLayout } from 'layouts'
import { FC } from 'react'

export const PaymentSuccessfulPage: FC = () => {
  return (
    <MainLayout>
      <div className='container'>
        <InformationCard
          title='Спасибо!'
          subtitle='Оплата прошла успешно'
          Icon={<CheckCircleOutlineIcon fontSize='large' color='primary' />}
          link='/appeals'
          linkText='Мои обращения'
        />
      </div>
    </MainLayout>
  )
}
